import React from 'react';
import { Field } from 'redux-form';
import moment from 'moment';
import { ReduxFormSelect } from '@common/components/FormElements';

const optionsForPerDateTimeRange = (options) =>
  options.map((option, index) => {
    const startDate = moment(option.startDate).format('MMM DD');
    const endDate = moment(option.endDate).format('MMM DD');
    const dateString = startDate === endDate ? startDate : `${startDate} - ${endDate}`;

    return {
      label: `${dateString} : ${option?.startTime?.substr(0, 5)} - ${option?.endTime?.substr(
        0,
        5
      )}`,
      value: index,
    };
  });

export const PerDateTimeRange = ({ id, options }) => (
  <Field
    component={ReduxFormSelect}
    name={`extras.${id}.option`}
    options={optionsForPerDateTimeRange(options)}
  />
);
